<template>
  <div>
    <el-dialog
      title="短信"
      custom-class=""
      :visible.sync="visible"
      width="1050px"
      :before-close="handleClose"
    >
      <div>
        <div class="sms-content">
          <section class="main">
            <el-form
              ref="formSearch"
              class="sms-box"
              :modle="formData"
              :disabled="isReadOnly"
              label-width="80px"
            >
              <div style="margin-bottom: 16px;" v-if="msgMore">已选择节点数:{{ msgMore }}个</div>
              <el-form-item required label="节点名称" style="position: relative;" v-if="!msgMore">
                <div class="name-wrap">
                  <el-input
                    class="name-wrap-input"
                    v-model="formData.name"
                    show-word-limit
                    maxlength="50"
                  ></el-input>
                  <div class="name-wrap-setName" @click="setName">智能命名</div>
                </div>
              </el-form-item>
              <el-form-item required label="编辑短信">
                <div class="textarea">
                  <el-input
                    class="textareaChange"
                    type="textarea"
                    :rows="5"
                    placeholder="请输入内容"
                    v-model="formData.content"
                    @paste.native="shopLinkCheck($event)"
                  >
                  </el-input>
                  <div class="footInfo">
                    <div>
                      <button
                        class="select"
                        @click.prevent="templateShow = true"
                      >
                        选择模板
                      </button>
                      <button class="keep" @click.prevent="handleShowModule">
                        保存模板
                      </button>
                      <span
                        >已输入
                        <span style="color: #fe4d45">{{
                          formData.content.length +
                          (this.formData.jdSmsSuffix ? this.formData.jdSmsSuffix.length : 0) + 2 +
                          this.TTip.length
                        }}</span>
                        个字（含签名及退订文字），预计
                        {{
                          Math.ceil(
                            sendInfoLength > 70
                              ? sendInfoLength / 67
                              : sendInfoLength / 70
                          )
                        }}
                        条短信
                      </span>
                    </div>
                    <div class="ask-content">
                      <span
                        style="
                          font-weight: normal;
                          margin-left: 8px;
                          color: #7f85e9;
                        "
                        >计费规则</span
                      >
                      <el-tooltip
                        class="item"
                        effect="light"
                        placement="top-start"
                      >
                        <div v-html="content1" slot="content" style="color:#999"></div>
                        <span class="question_icon" style="margin-left: 4px"
                          >?</span
                        >
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                <div class="footTips">
                  <img
                    src="@/assets/images/new_icon_waring_yellow.png"
                    style="
                      display: inline-block;
                      width: 14px;
                      height: 14px;
                      color: #ffffff;
                      margin: 4px 4px 0 3px;
                    "
                  />
                  <div style="line-height: normal;">
                    <div><span v-if="msgMore">1.</span>短信中短链必须是最新生成的，不可使用测试短链或是复制其他短链;</div>
                    <div v-if="msgMore">2.批量编辑短信节点保存时，每个短信节点会根据原始长链接重新生成短链。</div>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="短信签名">
                <div class="btnList">
                  <div
                    class="btnBox"
                    v-for="(item, index) in suffixList"
                    :key="'label' + index"
                    @click.prevent="switchSuffix(item)"
                    style="margin-bottom:5px"
                  >
                    <button class="btn">{{ item }}</button>
                    <span class="check" v-if="formData.jdSmsSuffix === item">
                      <i class="el-icon-check"></i>
                    </span>
                  </div>
                  <span
                    style="font-size: 14px; cursor: pointer"
                    class="btnListButtom"
                    @click="replaceSignature"
                    >更换</span
                  >
                </div>
              </el-form-item>
              <el-form-item label="过滤设置:">
                <el-checkbox :label="true" v-model="formData.filtrationBlacklistFlag">
                  过滤黑名单人群
                  <span
                    @click.stop="toBlack"
                    style="color: #7f85e9; margin-left: 8px"
                    >设置黑名单</span
                  >
                </el-checkbox>
                <el-checkbox :label="true" v-if="isPremissionShow" v-model="formData.filterAlreadySentFlag">
                  <span>屏蔽近</span>
                   <el-input
                    v-model.number="formData.filterDays"
                    @keyup.native="limitInput($event)"
                    onblur="value=value.replace(/[^\d]/g,'')"
                    style="width: 100px; padding: 0 6px"
                  >
                  </el-input>
                  <span>天已发送客户</span>
                </el-checkbox>
              </el-form-item>
              <el-form-item label="辅助工具:">
                <div class="tool">
                  <p @click.prevent="insertShortUrlShow = true">
                    <i class="iconfont iconbtn_duanwangzhi"></i>插入短网址
                  </p>
                </div>
              </el-form-item>
              <!-- 添加发送限制人数  v-if="sendType == '1'"-->
              <el-form-item label="发送人数:" >
              <div>
                <el-radio-group v-model="formData.sendIntType" @change="handleSendType">
                  <el-radio :label="0">不限</el-radio>
                  <el-radio :label="1">限制发送数</el-radio>
                </el-radio-group>
                <el-input  v-model="formData.smsLimit" placeholder="填写发送数" style="width: 120px; margin-left: 8px"
                  :disabled="formData.sendIntType === 0" @keyup.native="
                    formData.smsLimit = oninput(formData.smsLimit)
                  " @change="sendPeopleChange"></el-input>
              </div>
            </el-form-item>
            <!-- end -->
              <el-form-item label="短信测试:">
                <div class="test">
                  <!-- <el-input
                    v-model="mobiles"
                    placeholder="输入测试号码"
                    class="ipt"
                    @change="sendMobileChange"
                  ></el-input> -->
                  <el-select v-model="Selectmobiles" multiple collapse-tags placeholder="请选择" style="width: 264px;vertical-align: top;" @change="selectTestMobiles">
                        <el-option v-for="item in testOptions" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  <button class="sendTest" @click.prevent="handleShowSendTip()">
                    发送短信测试
                  </button>
                  <button class="record" @click.prevent="smsDialogs = true">
                    短信记录
                  </button>
                  <button class="record" style="width: auto;padding-left:4px ;padding-right: 4px;"  @click.prevent="showchangetestphone = true" >修改测试手机号</button>
                </div>
              </el-form-item>
            </el-form>
          </section>
          <!-- 短信预览效果 -->
          <div class="xiao-hug xiao_hug2">
            <div style="margin: 0 auto; width: 256px">
              <div
                class="mobile-box"
                :style="{ background: 'url(' + mobileScreen + ') no-repeat' }"
              >
                <div class="message-content">
                  【{{ jdSmsSuffixs?jdSmsSuffixs:formData.jdSmsSuffix }}】{{ formData.content }}{{ TTip }}
                </div>
              </div>
              <div class="mobile-tips">短信预览效果</div>
            </div>
          </div>
        </div>

        <div class="dialog-footer-btn">
          <el-button class="reset" @click="handleClose">取消</el-button>
          <el-button class="search" v-loading="updateLoading" :disabled="updateLoading || isReadOnly" @click="handleConfirm">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 选择模板 -->
    <sms-template
      v-if="templateShow"
      :isShow="templateShow"
      @close="templateChange"
    ></sms-template>
    <!-- 选择模板 -->
    <save-template
      :keepTmpShow="keepTmpShow"
      @onClose="handleSaveT"
    ></save-template>
    <!-- 插入短链接 -->
    <insert-short-dialog
      v-if="insertShortUrlShow"
      :typeSms="2"
      :zIndex="'4000'"
      @close="handleCloseShort"
    ></insert-short-dialog>
     <!-- 短信记录 -->
    <sms-template2
      :smsDialog="smsDialogs"
      v-if="smsDialogs"
      @transferName="transferName"
      @close="smsDialogClose"
    ></sms-template2>
    <!-- 发送确认弹窗 -->
    <send-confirm-dialog 
    :showSendConfirm.sync="showSendConfirm"
    :sendInfoLength="sendInfoLength"
    :phoneLenght="phoneLenght"
    :mobiles="mobiles"
    :TTip="TTip"
    :formData="formData"
    v-if="showSendConfirm">
    </send-confirm-dialog>
        
    <changetestphone :textPhoneId="textPhoneId" :nowtestMobiles="nowtestMobiles" v-if="showchangetestphone" @close="showchangetestphone = false" @mobilPhoneSubmit="mobilPhoneSubmit"></changetestphone>
  </div>
</template>

<script>
import mnode from "@/api/intelligentMarket/a_node";
import smsTemplate2 from "@/components/sms-templates-x.vue";
import smsTemplate from "@/views/serviceCenter/sms_template";
import saveTemplate from "@/components/save-template";
import sendConfirmDialog from './sendConfirmDialog';
import insertShortDialog from "@/components/insert-short-dialog";
import { getPrecisionJdSuffixList } from "@/api/precisionJdSuffix";
import { createTemplate } from "@/api/smsTemplates";
import changetestphone from "@/components/changetestphone.vue";
import { getValidSmsTestMobiles } from "@/api/smsSend";
export default {
  name: "",
  data() {
    return {
      textPhoneId:"",
      nowtestMobiles:"",
      showchangetestphone:false,
      testOptions: [], // 获取测试手机号
      Selectmobiles:[],
      isPremissionShow: false, // 屏蔽近X天发送客户的权限
      templateShow: false,
      keepTmpShow: false,
      formData: {
        nodeId: "",
        name: "",
        content: "",
        jdSmsSuffix: "",
        jdShortLink: "",
        realUrl: '',
        filtrationBlacklistFlag: false,
        filterAlreadySentFlag: false,
        filterDays: '',
        sendIntType:0,
        smsLimit: null, // 发送人数
      },
      TTip: "拒收请回复R",
      suffixList: [],
      // sendInfoLength: 0,
      insertShortUrlShow: false,
      mobiles: "",
      sendSmsTest: "",
      smsDialogs: false,
      mobileScreen: require("@/assets/images/mobileScreen.png"),
      updateLoading: false,
      showSendConfirm: false,
      phoneLenght: 0,
      jdSmsSuffixs:"",
      linkDTO:null
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    nodeId: Number,
    marketingId: Number,
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    nodeNumListBatchNumOne: {
      type: Array,
    },
    msgMore: {
      type: String
    },
  },
  components: {
    smsTemplate,
    smsTemplate2,
    saveTemplate,
    insertShortDialog,
    sendConfirmDialog,
    changetestphone
  },
  mounted() {
    this.getValidSmsTestMobiles()
    this.getSuffixList();
    this.handleShowPremission();
    // 批量设置不需要回显内容
    if(!this.msgMore){
      this.formData.nodeId = this.nodeId;
      mnode
      .getNode({
        nodeId: this.nodeId,
      })
      .then((res) => {
        if (res.code == "1") {
          this.formData.name = res.data.name;
          var smsNode = res.data.smsNode;
          if (smsNode.content && smsNode.content.indexOf('拒收请回复R') != '-1') {
            smsNode.content = smsNode.content.substr(0, smsNode.content.length-6)
          }
          this.formData.content = smsNode.content || '';
          this.formData.jdShortLink = smsNode.jdShortLink || '';
          this.formData.realUrl = smsNode.realUrl || '';
          this.formData.filterDays = smsNode.filterDays || '';
          if(smsNode.smsLimit){
           this.formData.sendIntType = 1
           this.formData.smsLimit = smsNode.smsLimit
          }else{
            this.formData.sendIntType = 0
            this.formData.smsLimit = '';
          }
          if (smsNode.filtrationBlacklistFlag) {
            this.formData.filtrationBlacklistFlag = true
          }
          if (smsNode.jdSmsSuffix) {
            this.formData.jdSmsSuffix = smsNode.jdSmsSuffix;
          }
          if (smsNode.filterAlreadySentFlag) {
            this.formData.filterAlreadySentFlag = smsNode.filterAlreadySentFlag;
          }
          if(smsNode.mediaTestMobiles){
            this.Selectmobiles = smsNode.mediaTestMobiles.split(',')
            this.selectTestMobiles()
          }
        }
      });
    }
  },
  computed: {
     viewVisible: {
      get: function () {
        return this.visible
      },
      set: function (newValue) {
        if (newValue) {
          this.$emit('update:visible', true)
        } else {
          this.$emit('update:visible', false)
        }
      }
    },
    content1() {
      return (
        "<div>1.70个字计1条短信，超过70字按照67字每条计费。</div>" +
        "<div>2.一个汉字，字母或标点空格都算作一个字。</div>" +
        '<div>3.带标签短信以实际发送为准，有可能超过默认字数。</div>' +
        '<div>4."签名"与"拒收请回复R"包含在字数中。</div>' +
        '<div>5.短链及前后空格占17字或15字，插入短网址的原始域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，短链转换后的字符数及前后空格占17字（具体见插入链接说明）</div>' +
        '<div>6.含插入#评价链接#或#付款链接#短信变量，变量转换后，实际长度为15字。。</div>'
      );
    },
     sendInfoLength() {
      return (
        this.formData.content.length +
        this.formData.jdSmsSuffix.length +
        2 +
        this.TTip.length
      );
    },
    permissions() {
      return this.$store.getters.loginUserInfo.permissions;
    },
  },
  watch: {
    permissions(nVal, oVal) {
      if (nVal.indexOf('hide:filter:send') != '-1') {
        // 显示屏蔽发送按钮
        this.isPremissionShow = true;
      }
    },
  },
  methods: {
    mobilPhoneSubmit(val){
      this.getValidSmsTestMobiles()
      this.showchangetestphone = false
    },
    getValidSmsTestMobiles() {
      // 获取测试手机号
      getValidSmsTestMobiles().then(res => {
        if (res.code == 1) {
          this.Selectmobiles = [];
          this.testOptions = res.data.smsTestMobiles
          this.nowtestMobiles = res.data.smsTestMobiles.join(',')
          this.textPhoneId = res.data.id
        }
      })
    },
    // 短信测试手机号 
    selectTestMobiles(val) {
      this.mobiles = this.Selectmobiles.join(',')
    },
    // 不可输入小数
    oninput(val) {
      return val ? val.replace(/\D/g, "") : "";
    },
    // 发送人数的限制
    sendPeopleChange(val) {
      if (val == 0) {
        this.formData.smsLimit = "";
        this.$message.warning("人数只能输入正整数");
      } 
    },
    // 发送限制数
    handleSendType(val) {
      this.formData.smsLimit = "";
    },
    // 智能命名
    setName(){
      let nodeId = this.nodeId
      if(this.msgMore){
        nodeId = this.nodeNumListBatchNumOne[0].nodeId
      }
      mnode.getAutoName(nodeId).then(res=>{
        console.log(res);
        if(res.code){
          this.formData.name = res.data
        }else if (res.code == undefined && res.data.code === 0){
          this.$message.warning(res.data.message)
        }
      })
    },
    handleShowPremission() {
      // 按钮权限显示
      if (this.permissions && this.permissions.indexOf('hide:filter:send') != '-1') {
        // 显示屏蔽发送按钮
        this.isPremissionShow = true;
      }
    },
    limitInput(event) {
      if (event.target.value == '0') {
        event.target.value = ''
      } else {
        event.target.value = event.target.value.replace(/[^\d]/g,'')
      }
    },
    async handleShowSendTip() {
      var mobiles = this.mobiles;
      if (!/[\S]+/.test(mobiles)) {
        this.$message.warning("手机号不能为空，请输入正确的手机号 !");
        return;
      }
      // 替换逗号(不论中/英文逗号，都替换成英文逗号)
      mobiles = mobiles.replace(/(,|，)/g, ",");
      // 切换成数组
      var mobleList = mobiles.split(",");
      var mobileArr = [];
      for (var i = 0; i < mobleList.length; i++) {
        if (/^1[3456789]\d{9}$/.test(mobleList[i])) {
          mobileArr.push(mobleList[i]);
        }
      }

      var newMobleArr = [];
      for (var i = 0; i < mobileArr.length; i++) {
        if (newMobleArr.indexOf(mobileArr[i]) == -1) {
          newMobleArr.push(mobileArr[i]);
        }
      }
      if (newMobleArr.length <= 0) {
        this.$message.warning("号码无效，请输入有效号码 !");
        return;
      }
      // if (newMobleArr.length > 5) {
      //   this.$message.warning("测试发送最多只能发送5个有效号码 !");
      //   return;
      // }

      var content = this.formData.content;

      // 敏感词检测
      const checkResult = await this.$wordCheck({ content: this.formData.content })
      if (checkResult.code != 1) {
        return this.$message.error(checkResult.message)
      }

      if (content && content.trim().length > 0) {
        this.mobiles = newMobleArr.join(",");
        // this.strLenght = content.length + this.formData.jdSmsSuffix.length;
        this.phoneLenght = this.mobiles.split(",").length;
        this.showSendConfirm = true;
      } else {
        this.$message.warning("短信内容不能为空哦！");
      }
    },
    smsDialogClose(data) {
      this.smsDialogs = data;
    },
    transferName() {
      this.smsDialogs = false;
    },

    getSuffixList() {
      var type = '2'
      getPrecisionJdSuffixList(type).then(res => {
         if (res.code == "1") {
          this.suffixList = res.data;
          if (!this.formData.jdSmsSuffix) {
            this.formData.jdSmsSuffix = this.suffixList[0] || "";
            this.jdSmsSuffixs = this.suffixList[0]
            console.log('999999',this.jdSmsSuffixs);
          }
        }
      })
    },
    // 关闭短链接
    handleCloseShort(val, obj) {
      this.insertShortUrlShow = false;
      console.log(obj);
      if (val) {
        // 官方短链接
        this.formData.jdShortLink = obj.shortLink;
        // this.jdShortLinkList.push(obj);
        this.formData.realUrl = obj.originUrl;
        this.formData.content =
        this.formData.content + " " + obj.shortLink + " ";
        this.linkDTO = obj.param
      }
    },
    templateChange(val, item) {
      if (val == true) {
        this.formData.content = item.content;
      }
      this.templateShow = false;
    },
    handleShowModule() {
      this.keepTmpShow = true;
    },
    handleSaveT(param) {
      this.keepTmpShow = false;
      if (param.flag) {
        var id = param.value;
        var paramX = {
          tid: id,
          content: this.formData.content,
        };
        createTemplate(paramX).then((res) => {
          if (res.code == "1") {
            this.$message.success("保存模板成功！");
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },

    handleClose() {
      this.viewVisible = false;
    },
    isRepeat(arr) {
      var hash = {};
      for (var i in arr) {
        if (hash[arr[i]]) {
          return true;
        }
        // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
        hash[arr[i]] = true;
      }
      return false;
    },
    handleConfirm() {
      // 节点名称
      if(!this.msgMore && !this.formData.name){
        return this.$message.error("节点名称不能为空")
      }
      if(!this.formData.content){
        return this.$message.error("短信内容不能为空")
      }
      if(this.formData.filterAlreadySentFlag && !this.formData.filterDays){
        return this.$message.error("屏蔽已发送客户天数不能为空")
      }
      if(this.formData.sendIntType == 1 && !this.formData.smsLimit){
        return this.$message.error("限制发送数不能为空")
      }
      if (this.isRepeat(this.formData.content.match(/3\.cn/g))) {
        this.$message.warning("官方插入的短链接不允许超过1个哦！");
        return;
      }
      // this.formData.filtrationBlacklistFlag = (this.formData.filtrationBlacklistFlag == '1')
      var param = JSON.parse(JSON.stringify(this.formData))
      param.jdSmsSuffix = this.jdSmsSuffixs?this.jdSmsSuffixs:param.jdSmsSuffix;
      param.content = param.content + this.TTip;
      if (param.jdShortLink) {
        if (param.content.indexOf(param.jdShortLink) == '-1') {
          param.jdShortLink = '';
          param.realUrl = '';
        }
      }
      this.updateLoading = true;
      if(param.sendIntType==0){
        param.smsLimit = ''
      }
      let fn = mnode.updateSmsDetail
      if(this.msgMore){
        fn = mnode.batchSmsUpdate
        param.nodeIdList = this.nodeNumListBatchNumOne.map(item=>item.nodeId)
        delete param.nodeId
        if(this.linkDTO){
          param.linkDTO = this.linkDTO
        }
      }
      // 测试手机号
      if(this.Selectmobiles && this.Selectmobiles.length){
        param.mediaTestMobiles = this.Selectmobiles.join(',')
      }
      fn(param).then((res) => {
        this.updateLoading = false;
        if (res.code === 1) {
          this.viewVisible = false;
          this.$emit('change-name', param)
        } else {
          this.$message.error(res.message)
        }
      });
    },
    replaceSignature() {},
    toBlack() {},
    sendMobileChange() {},
  },
};
</script>

<style scoped lang="scss">
.sms-content {
  position: relative;
}
.xiao_hug2 {
  position: absolute;
  top: 0;
  left: 720px;
}
.mobile-box {
  position: relative;
  width: 256px;
  height: 504px;
  .message-content {
    position: absolute;
    word-wrap: break-word;
    background-color: #fafafa;
    max-height: 250px;
    overflow-y: auto;
    padding: 12px 12px;
    border-radius: 6px;
    padding-right: 5px;
    width: 210px;
    font-size: 14px;
    line-height: 20px;
    left: 50%;
    margin-left: -104.665px;
    text-align: left;
    top: 25.4%;
  }
}
.mobile-tips {
  margin-top: 16px;
  font-size: 16px;
  text-align: center;
}
.tool {
  display: flex;
  align-items: center;
  height: 32px;
  p {
    box-sizing: border-box;
    padding: 0 8px;
    margin: 0 8px 0 0;
    font-size: 14px;
    border-radius: 3px;
    background-color: #f7f8fe;
    border: 1px solid #7f85e9;
    color: #7f85e9;
    &:hover {
      background: rgba(174, 179, 241, 0.16);
      border: 1px solid #7f85e9 !important;
      color: #7f85e9 !important;
    }
    &:active {
      background: rgba(174, 179, 241, 0.24);
      border: 1px solid #7f85e9 !important;
      color: #7f85e9;
    }
  }
}
.btnList {
  display: flex;
  align-items: center;
  height: 32px;
  button {
    border: none;
    background-color: white;
    outline: none;
    padding: 0;
    margin: 0;
    border-radius: 2px;
    cursor: pointer;
  }
  .btnListButtom {
    color: rgb(127, 133, 233);
    &:hover {
      color: #fe4d45;
    }
  }
  .btnBox {
    position: relative;
    overflow: hidden;
    height: 31px;
    margin-right: 16px;
    .btn {
      padding: 5px 12px;
      height: 31px;
      border: 1px solid rgba(254, 77, 69, 1);
      color: #fe4d45;
      cursor: pointer;
    }
    .check {
      position: absolute;
      right: -16px;
      bottom: -15px;
      width: 30px;
      height: 30px;
      background-color: #fe4d45;
      border-radius: 50%;
    }
    i {
      position: absolute;
      right: 16px;
      bottom: 15px;
      font-size: 10px;
      color: #fff;
    }
  }
}
.test {
  font-size: 14px;
  button {
    border: none;
    background-color: white;
    outline: none;
    padding: 0;
    margin: 0;
    border-radius: 2px;
    width: 98px;
    height: 32px;
    line-height: 31px;
    cursor: pointer;
    transition: all 0.2s;
  }
  .ipt {
    width: 240px;
    margin: 0 8px 0 0px;
  }
  .sendTest {
    color: #fe4d45;
    border: 1px solid rgba(254, 77, 69, 1);
    &:hover {
      background-color: #fe4d45;
      color: #fff;
    }
  }
  .record {
    margin: 0 0px 0 8px;
    color: #999999;
    border-radius: 3px;
    border: 1px solid #cccccc;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}
.sms-box {
  width: 680px;
}
.textarea {
  box-sizing: border-box;
  padding: 6px 6px 10px;
  width: 100%;
  background: rgba(249, 250, 251, 1);
  border: 1px solid rgba(238, 238, 238, 1);
  border-radius: 2px;
  .footInfo {
    display: flex;
    justify-content: space-between;
    margin-top: 9px;
    font-size: 14px;
    color: #333;
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 76px;
      height: 28px;
      outline: none;
      border: none;
      background-color: white;
      border-radius: 2px;
      font-size: 14px;
    }
    div {
      display: flex;
      align-items: center;
    }
    .select {
      // margin: 0 10px 0 8px;
      width: 76px;
      height: 28px;
      opacity: 1;
      border-radius: 3px;
      font-size: 13px;
      margin-right: 8px;
      cursor: pointer;
      border: 1px solid #fe4d45;
      color: #fe4d45;
      background-color: #fff4f4;
      &:hover {
        color: #fe4d45;
        background-color: #ffe5e5;
      }
    }
    .question_icon {
      width: 14px;
      height: 14px;
      color: #7f85e9 !important;
      display: inline-block;
      line-height: 12px !important;
      text-align: center;
      border-radius: 14px;
      border: 1px solid #7f85e9;
      font-size: 12px !important;
      font-weight: normal !important;
      margin-left: 8px;
      &:hover {
        color: #fe4d45 !important;
        border: 1px solid #fe4d45;
      }
    }
    .keep {
      // margin: 0 10px 0 8px;
      width: 76px;
      height: 28px;
      border-radius: 3px;
      font-size: 13px;
      /* font-family: PingFang SC; */
      font-weight: 400;
      margin-right: 8px;
      cursor: pointer;
      color: #ffffff;
      background-color: #fe4d45;
      &:hover {
        color: #fff;
        opacity: 0.9;
        background-color: #fe4d45;
      }
    }
  }
}
.footTips {
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  margin-top: 8px;
  padding-left: 12px;
  background: rgba(255, 250, 238, 1);
  border: 1px solid rgba(255, 185, 94, 1);
  border-radius: 2px;
  color: #333;
  font-size: 14px;
  padding: 8px 10px;
}
.dialog-footer-btn {
  text-align: center;
  margin-top: 110px;
  .search {
    width: 98px;
    height: 32px;
    color: #ffffff;
    font-size: 14px;
    border-radius: 3px;
    border: 1px solid #fe4d45;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .reset {
    width: 98px;
    height: 32px;
    color: #666666;
    font-size: 14px;
    margin: 0px 0px 0 800px;
    border-radius: 3px;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}
.setName{
 position: absolute;
 right:45px;
 top:0px;
 color: #a585ea;
 cursor: pointer;
 &:hover{
   color: #fe4d45;
 }
}
.name-wrap{
  display: flex;
  align-items: center;
  white-space: nowrap;
  &-input{
    width: 346px;
    /deep/.el-input__inner{
      padding-right: 50px !important;
    }
  }
  &-setName{
    color: #7f85e9;
    cursor: pointer;
    margin-left: 8px;
  }
}
</style>